import angular from "angular";
import { AbstractAccessorService } from "../../common/data-access/abstract-accessor.service";
import { IDataAccessor } from "../../common/data-access/data-accessor";
import { IResponse } from "../../common/data-access/model/response";
import { Token } from "../../common/data-access/model/token";

import { IClientService } from "./client";
import { ActionKey } from "./client.config";
type ClientInfo = {
    clientId: number,
    // clientName: string,
    // wcClientId: number,
}
type ClientData = {
    srcRole: string,
    srcUserId: number | undefined,
    tgtRole:string,
    tgtUserId:number
}

export class ClientService extends AbstractAccessorService<any> implements IClientService {
    public readonly $name: string = "clientService";

    public static readonly $inject: string[] = ["$accessor", "$q"];

    constructor(
        public $accessor: IDataAccessor<any>,
        public $q: angular.IQService,
    ) {
        super();
    }

    public getClientInfo(clientId: number, userName: string, token: Token,qpsonStoreUrlTag:string): angular.IPromise<IResponse<any>> {
        let deferred = this.$q.defer<any>();
        if (angular.isNumber(clientId) && token && token.token_type && token.access_token) {
            let clientInfo: ClientInfo | null = this.getLocalClientInfo(qpsonStoreUrlTag);
            if (clientId == 0) {
                //*匿名处理
                if (clientInfo && angular.isNumber(clientInfo.clientId)) {
                    deferred.resolve(clientInfo.clientId);
                } else {
                    let tempWcId;
                    this.getGlobalId(token).then((respId) => {
                        if (respId.success) {
                            tempWcId = respId.data;
                            let name = userName && userName != "" ? userName : "anonymous user";
                            return this.creationClient(tempWcId, name, token, true);
                        } else {
                            deferred.reject(respId);
                        }
                    }).then((clientIdResp) => {
                        if(clientIdResp){
                            this.saveLocalClientInfo(tempWcId, Number(clientIdResp.data._id),qpsonStoreUrlTag);
                            deferred.resolve(clientIdResp.data._id);
                        }
                    }).catch((error) => {
                        deferred.reject(error);
                    });
                }
            } else if (clientId > 0) {
                //*非匿名处理
                if (clientInfo && angular.isNumber(clientInfo.clientId)) {
                    this.findClientById(clientId, token).then((respData) => {
                        //*临时用户图库数据移动到非临时用户
                        this.mergeTempLibrary(token, {
                            srcRole: "client",
                            srcUserId: clientInfo?.clientId,
                            tgtRole: "client",
                            tgtUserId: respData.data._id
                        }).then((resp) => {
                            console.log(resp);
                        }, (error) => {
                            console.log("mergeTempLibrary error");
                            console.error(error);
                        });
                        deferred.resolve(respData.data._id);
                    }, (error) => {
                        if (error && error.data && error.data.data && Number(error.data.data.code) == 96000102) {
                            this.creationClient(clientId, userName, token).then((respClient) => {
                                //*临时用户图库数据移动到非临时用户
                                this.mergeTempLibrary(token, {
                                    srcRole: "client",
                                    srcUserId: clientInfo?.clientId,
                                    tgtRole: "client",
                                    tgtUserId: Number(respClient.data._id)
                                }).then((resp) => {
                                    console.log(resp);
                                }, (error) => {
                                    console.log("mergeTempLibrary error");
                                    console.error(error);
                                });
                                deferred.resolve(respClient.data._id);
                            }, (error) => {
                                deferred.reject(error);
                            });
                        } else {
                            deferred.reject(error);
                        }
                    });
                } else {
                    this.findClientById(clientId, token).then((respData) => {
                        deferred.resolve(respData.data._id);
                    }, (error) => {
                        if (error && error.data && error.data.data && Number(error.data.data.code) == 96000102) {
                            this.creationClient(clientId, userName, token).then((respClient) => {
                                deferred.resolve(Number(respClient.data._id));
                            }, (error) => {
                                deferred.reject(error);
                            });
                        } else {
                            deferred.reject(error);
                        }
                    });
                }
            }
        } else{
            console.log(clientId);
            console.log(token);
            deferred.reject("getClientInfo Missing Parameters");
        }
        return deferred.promise;
    }

    public getLocalClientInfo(qpsonStoreUrlTag:string) {
        let clientInfo: ClientInfo | null = null;
        let allCookies = document.cookie;
        if (allCookies && allCookies != '') {
            let cookieList = allCookies.split(";");
            for (let i = 0; i < cookieList.length; i++) {
                let cookieData = cookieList[i];
                if (cookieData.indexOf("clientInfo") >= 0) {
                    let clientInfoList = cookieData.split("=");
                    try {
                        clientInfo = JSON.parse(clientInfoList[clientInfoList.length - 1]);
                    } catch (e) {
                        console.error(clientInfoList);
                        console.error(e);
                    }
                    break;
                }
            }
        }
        // let wcClientIdName  = `${qpsonStoreUrlTag}_wcClientId`;
        let clientIdName = `${qpsonStoreUrlTag}_clientId`
        // let clientName = `${qpsonStoreUrlTag}_clientName`
        if(clientInfo && clientIdName){
            let NewClientInfo={
                clientId: clientInfo[clientIdName]
                // NewClientInfo["wcClientId"] = clientInfo[wcClientIdName];
                // NewClientInfo["clientName"] = clientInfo[clientName];
            };
            return NewClientInfo;
        }else{
            return null;
        }
    }



    /**
     * @param {object} token 
     * @param {string} rootPath 
     * @param {string} appPath 
     * @description 获取全局唯一 ID 用于做临时用户的 wcClientId 
     */
    public getGlobalId(token: Token): angular.IPromise<IResponse<any>> {
        // let deferred = this.$q.defer();
        let deferred = this.$q.defer<IResponse<any>>();
        if (token && token.token_type && token.access_token) {
            // let url = rootPath + appPath + '/api/common/key';
            // $http({
            //     url: url,
            //     method: 'GET',
            //     headers: {
            //         Authorization: token.token_type + ' ' + token.access_token,
            //         "access-control-allow-origin": "*"
            //     }
            // }).then(function (resp) {
            //     resp.status && resp.data ? deferred.resolve(resp.data) : deferred.reject(resp);
            // }, function (err) {
            //     deferred.reject(err);
            // });
            return this.$accessor<any, {}, ActionKey>(this.$name, "getGlobalId", {
                headers: {
                    Authorization: token.token_type + ' ' + token.access_token,
                    "access-control-allow-origin": "*"
                },
                parameter: {

                }
            })

        } else {
            console.log(token);
            deferred.reject("getGlobalId Missing Parameters");
        }
        return deferred.promise;


    }


    public creationClient(wcClientId: number, clientName: string, token: Token, isTemp?: boolean): angular.IPromise<IResponse<any>> {
        let deferred = this.$q.defer<IResponse<any>>();
        if (angular.isNumber(wcClientId) && token) {
            let requestData = {
                "clientId": wcClientId,
                "clientName": clientName,
                "createClientRoot": true,
                "clazz": "com.qpp.cgp.domain.partner.client.Client",
                "isTemp": isTemp
            }
            //*是否为 临时用户处理
            isTemp && (requestData.isTemp = true);
            // $http({
            //     url: rootPath + appPath + "/api/partner/clients",
            //     method: 'POST',
            //     data: requestData,
            //     headers: {
            //         Authorization: token.token_type + ' ' + token.access_token,
            //         "access-control-allow-origin": "*"
            //     }
            // }).then(function (resp) {
            //     resp.status == 200 && resp.data && resp.data.success && resp.data.data && resp.data.data != "" ? deferred.resolve(resp.data.data) : deferred.reject(resp);
            // }, function (err) {
            //     deferred.reject(err);
            // });
            return this.$accessor<any, {}, ActionKey>(this.$name, "creationClient", {
                data: requestData,
                headers: {
                    Authorization: token.token_type + ' ' + token.access_token,
                    "access-control-allow-origin": "*"
                }
            })
        } else {
            console.log({ wcClientId: wcClientId, token: token });
            deferred.reject("getClientId Missing Parameters");
        }
        return deferred.promise;
    }


    /**
     * @param {number} wcClientId 
     * @param {number} clientId 
     * @description 存储ClientInfo信息到浏览器 cookie 中
     */
    public saveLocalClientInfo(wcClientId:number, clientId:number,qpsonStoreUrlTag:string) {
        if (angular.isNumber(wcClientId) && angular.isNumber(clientId)) {
            // let wcClientIdName = qpsonStoreUrlTag + "_wcClientId";
            let clientIdName = qpsonStoreUrlTag + "_clientId";
            // let clientName = qpsonStoreUrlTag + "_clientName";
            let clientInfoObj={ };                
            // clientInfoObj[wcClientIdName]=wcClientId,
            clientInfoObj[clientIdName]=clientId;
            // clientInfoObj[clientName]= "anonymous user"
            let clientInfo = JSON.stringify(clientInfoObj);
            document.cookie = `clientInfo=${clientInfo}`;
        } else {
            console.error("saveLocalClientInfo error");
            console.error({ wcClientId: wcClientId, clientId: clientId });
        }
    }


    public findClientById(wcClientId:number, token:Token): angular.IPromise<IResponse<any>> {
        let deferred = this.$q.defer<IResponse<any>>();
        if (angular.isNumber(wcClientId) && token) {
            // let url = rootPath + appPath + `/api/partner/clients/externalClient/${wcClientId}`;
            // $http({
            //     url: url,
            //     method: 'GET',
            //     headers: {
            //         Authorization: token.token_type + ' ' + token.access_token,
            //         "access-control-allow-origin": "*"
            //     }
            // }).then(function (resp) {
            //     resp.status == 200 && resp.data && resp.data.data && resp.data.success ? deferred.resolve(resp.data.data) : deferred.reject(resp);
            // }, function (err) {
            //     deferred.reject(err);
            // });
            return this.$accessor<any, {}, ActionKey>(this.$name, "findClientById",{
                headers: {
                    Authorization: token.token_type + ' ' + token.access_token,
                    "access-control-allow-origin": "*"
                },
                parameter: {
                    wcClientId:wcClientId
                }
            })
        } else {
            console.log({ wcClientId: wcClientId, token: token});
            deferred.reject("findClientById Missing Parameters");
        }
        return deferred.promise;
    }


    /**
     * @param {token} token  token.token_type token.access_token
     * @param {clientData} clientData 
     ** clientData.srcRole   迁移的用户标识 :client(默认 当前只支持client)
     ** clientData.srcUserId 迁移的用户ID  :clientId(临时用户的 clientId)
     ** clientData.tgtRole   迁移目标的用户标识 :client(默认 当前只支持client)
     ** clientData.tgtUserId 迁移目标的用户ID  :clientId(非临时用户 clientId)
     * @description 移动匿名用户的图库数据到当前非匿名用户图库中
     */
     public mergeTempLibrary(token:Token, clientData:ClientData): angular.IPromise<IResponse<any>> {
        let deferred = this.$q.defer<IResponse<any>>();
        if ( token && token.token_type && token.access_token && clientData) {
            // let url = rootPath + appPath + `/api/file/library/migrate/${clientData.srcRole}/${clientData.srcUserId}/to/${clientData.tgtRole}/${clientData.tgtUserId}`;
            // $http({
            //     url: url,
            //     method: 'POST',
            //     headers: {
            //         Authorization: token.token_type + ' ' + token.access_token,
            //         "access-control-allow-origin": "*"
            //     }
            // }).then(function (resp) {
            //     resp.status == 200 && resp.data && resp.data.success && resp.data ? deferred.resolve(resp.data) : deferred.reject(resp);
            // }, function (err) {
            //     deferred.reject(err);
            // });
            return this.$accessor<any, {}, ActionKey>(this.$name, "mergeTempLibrary",{
                headers: {
                    Authorization: token.token_type + ' ' + token.access_token,
                    "access-control-allow-origin": "*"
                },
                parameter: {
                    srcRole:clientData.srcRole,
                    srcUserId:clientData.srcUserId,
                    tgtRole:clientData.tgtRole,
                    tgtUserId:clientData.tgtUserId
                }
            })
        } else {
            console.log(token);
            console.log(clientData);
            deferred.reject("mergeTempLibrary Missing Parameters");
        }
        return deferred.promise;
    }
}
